export default {"src":"/_next/static/media/telegram.bd627ed0.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};